import { TEXTS_VARIABLE } from 'src/app/shared/constants/constants-texts';
import { IEquisBreadcrumbTree } from 'src/app/shared/models/breadcrumb';
import { URL_DOMAIN } from 'src/environments/environment';

export const createBreadcrumbNode = ({
  title,
  path,
  params = '',
  active = true,
  parentTitle = '',
  id,
  parentId = '',
}: Partial<IEquisBreadcrumbTree> & {
  title: string;
  path: string;
  id: string;
}): IEquisBreadcrumbTree => {
  return {
    title,
    path,
    children: [],
    params,
    active,
    parentTitle,
    id,
    parentId,
  };
};

export const homeNode = createBreadcrumbNode({
  title: 'Inicio',
  path: URL_DOMAIN,
  id: 'inicio',
  active: false,
});
export const helpCenterNode = createBreadcrumbNode({
  title: TEXTS_VARIABLE.breadcrumb.HelpCenter,
  path: '',
  id: 'ayuda',
  parentTitle: homeNode.title,
  parentId: homeNode.id,
});
export const emptyNode = createBreadcrumbNode({
  title: '',
  path: '/',
  id: 'empty',
  parentTitle: helpCenterNode.title,
  parentId: helpCenterNode.id,
});
export function buildBreadcrumbTrail(
  current: IEquisBreadcrumbTree,
  preloaded?: IEquisBreadcrumbTree[],
): IEquisBreadcrumbTree[] {
  if (preloaded && preloaded.length > 0) {
    return [...preloaded, current];
  }
  return [current];
}
